Namespace 'Common'

class Common.AttachmentType
  @VIDEO = 'video'
  @IMAGE = 'image'
  @AUDIO = 'audio'
  @FILE = 'file'
